import {
  Directive,
  ElementRef,
  HostListener,
  QueryList,
  ContentChildren,
  AfterContentInit,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
} from '@angular/core';
import { Actions, ofActionCompleted, ofActionSuccessful } from '@ngxs/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ChatWidgetMessageComponent } from '../components/chat-widget-message/chat-widget-message.component';
import { SendMessage } from '../store';

@Directive({
  selector: '[brnChatScroll]',
})
export class ChatScrollDirective
  implements OnInit, OnDestroy, AfterContentInit {
  @ContentChildren(ChatWidgetMessageComponent)
  messages!: QueryList<ChatWidgetMessageComponent>;

  @Output() loadMore = new EventEmitter<any>();

  private stickBottom = true;
  private unsubscribe = new Subject();

  private get sticked(): boolean {
    if (this.stickBottom) {
      return true;
    } else {
      return this.element.nativeElement.scrollTop >= 0;
    }
  }

  private get onTop(): boolean {
    const scrollPos = this.element.nativeElement.scrollTop;
    const scrollHeight =
      this.element.nativeElement.scrollHeight -
      this.element.nativeElement.offsetHeight;

    return scrollHeight + scrollPos <= 1;
  }

  @HostListener('scroll', ['$event'])
  onScroll(event: Event): void {
    if (this.element.nativeElement.scrollTop >= 0) {
      this.stickBottom = true;
    } else {
      this.stickBottom = false;
    }
    if (this.onTop) {
      event.preventDefault();
      event.stopPropagation();
      this.loadMore.emit();
    }
  }

  constructor(private element: ElementRef, private actions: Actions) {}

  ngOnInit(): void {
    this.actions
      .pipe(ofActionCompleted(SendMessage), takeUntil(this.unsubscribe))
      .subscribe(() => {
        this.stickBottom = true;
        this.scrollToBottom();
      });
  }

  ngAfterContentInit(): void {
    this.messages.changes.subscribe((res) => {
      this.scrollToBottom();
    });
  }

  scrollToBottom(): void {
    if (this.sticked) {
      this.element.nativeElement.scrollTop = 1;
      setTimeout(() => {
        this.stickBottom = true;
      }, 10);
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
